import { __assign, __rest } from "tslib";
import React from 'react';
import { PnmacImage, PnmacNavigation, HomeCard } from 'pnmac-universal-components';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import SimplyIOATileNew from '../../components/SimplyIOATileNew';
import { AmortizationCardPicker } from './AmortizationCardPicker';
import HappyHouseSVG from '../../assets/happy-house.svg';
import HomeValueSVG from '../../assets/home-value.svg';
import LearningCenterSVG from '../../assets/learning-center.svg';
import CalculatorsSVG from '../../assets/calculators.svg';
import TakeActionSVG from '../../assets/take-action.svg';
export var PennymacCards = function (_a) {
  var _b, _c;
  var matches = _a.matches,
    enabled = _a.enabled,
    props = __rest(_a, ["matches", "enabled"]);
  var layout = props.layout,
    translations = props.translations,
    trackerDispatcher = props.trackerDispatcher;
  var allowedSimplyIOAScriptNums = [1, 2, 4];
  var iconSize = matches.small ? 40 : 65;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "ApplyOnlineTile",
    title: translations === null || translations === void 0 ? void 0 : translations.ApplyOnline,
    icon: function () {
      return PnmacImage(layout.mobile ? 'takeAction' : TakeActionSVG, iconSize, 'Take action icon');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.ApplyOnlineMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.ApplyNow,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      var _a;
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Apply Online Button Clicked', 3);
      PnmacNavigation(__assign({
        action: "".concat(layout.pennyHomeUrl, "api/main/redirect?goingto=BlendUrl&ids_token=").concat(layout.token, "&&user=").concat((_a = layout.userProfile) === null || _a === void 0 ? void 0 : _a.user_id),
        wind: true,
        target: '_blank'
      }, props));
    }
  }), /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "HomeValueEstimatorTile",
    title: translations === null || translations === void 0 ? void 0 : translations.HomeValueEstimator,
    icon: function () {
      return PnmacImage(layout.mobile ? 'homeValue' : HomeValueSVG, iconSize, 'House icon', 'css');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.HomeValueMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.GetEstimates,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Home value estimator Button Clicked', 4);
      if (layout.baseRoute == '/') {} else {
        PnmacNavigation(__assign({
          action: "https://www.pennymac.com/home-value-estimator",
          wind: true,
          target: '_blank'
        }, props));
      }
    }
  }), /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "CalculatorsTile",
    title: translations === null || translations === void 0 ? void 0 : translations.Calculators,
    icon: function () {
      return PnmacImage(layout.mobile ? 'calculators' : CalculatorsSVG, iconSize, 'Calculators', 'css');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.CalculatorsMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.MortgageCalculators,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Mortgage calculator Button Clicked', 7);
      PnmacNavigation(__assign({
        action: "https://www.pennymac.com/mortgage-calculators",
        wind: true,
        target: '_blank'
      }, props));
    }
  }), /*#__PURE__*/React.createElement(AmortizationCardPicker, __assign({
    matches: matches,
    enabled: enabled
  }, props)), allowedSimplyIOAScriptNums.includes((_c = (_b = layout === null || layout === void 0 ? void 0 : layout.simplyIOAData) === null || _b === void 0 ? void 0 : _b.scriptNumber) !== null && _c !== void 0 ? _c : 0) ? (/*#__PURE__*/React.createElement(SimplyIOATileNew, {
    matches: matches,
    navigation: props.navigation,
    isEscrow: false
  })) : (/*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "LearningCenterTile",
    title: translations === null || translations === void 0 ? void 0 : translations.LearningCenter,
    icon: function () {
      return PnmacImage(layout.mobile ? 'learningCenter' : LearningCenterSVG, iconSize, 'Chat message icon', 'css');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.LearningcenterMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.PennymacBlog,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'View our blog Button Clicked', 6);
      PnmacNavigation(__assign({
        action: "https://www.pennymac.com/blog",
        wind: true,
        target: '_blank'
      }, props));
    }
  })), /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "AboutUsTile",
    title: translations === null || translations === void 0 ? void 0 : translations.AboutUs,
    icon: function () {
      return PnmacImage(layout.mobile ? 'happyHouse' : HappyHouseSVG, iconSize, 'Happy House', 'css');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.AboutUseMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.LearnMore,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'About Us Button Clicked', 7);
      PnmacNavigation(__assign({
        action: "https://www.pennymac.com/about-us",
        wind: true,
        target: '_blank'
      }, props));
    }
  }));
};